import { ALL_NAV_ITEMS } from "@/components/layout/nav-config"
import { QuickAccessTile } from "./QuickAccessTile"

export function QuickAccessSection() {
  const items = ALL_NAV_ITEMS.filter((i) => i.path !== "/")

  return (
    <section className="space-y-3">
      <h2 className="text-sm font-semibold text-muted-foreground">
        Szybki dostęp
      </h2>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-6">
        {items.map((item) => (
          <QuickAccessTile key={item.path} item={item} />
        ))}
      </div>
    </section>
  )
}
